import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, useTheme } from '@mui/material';
import { MarketActivityIndicator, MarketHeader } from '@market/react';

const LoadingDecision = (props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const { open } = props;

  return (
    <Dialog fullWidth maxWidth="xs" open={open}>
      <MarketActivityIndicator style={{ margin: theme.spacing(4, 4, 0) }} />
      <MarketHeader style={{ margin: theme.spacing(0, 4) }}>
        <h1>{t('checkout.financeApp.modals.loading.title')}</h1>
      </MarketHeader>
      <DialogContent sx={{ px: 4, pb: 4 }}>
        <p>{t('checkout.financeApp.modals.loading.body')}</p>
      </DialogContent>
    </Dialog>
  );
};

export default LoadingDecision;
